import { Select } from '@ts/storybook';
import { IForm } from '@ts/ui-models';

const UnitSystem = (props: IForm) => {
  const { values, mode, onCallbackChange } = props;
  const systems = [
    { label: 'Metric', value: 'metric' },
    { label: 'Imperial', value: 'imperial' },
    { label: 'Convert only status indicators', value: 'convertOnlyStatusInds' },
  ];

  return (
    <Select
      label="Unit system"
      value={values.value.unitSystem}
      onChange={onCallbackChange('value.unitSystem')}
      disabled={mode === 'view'}
      options={systems}
    />
  );
};

export default UnitSystem;
